import { useScrollReveal } from "@/hooks/useScrollReveal"

const checkItems = [
  {
    icon: "📚",
    label: "Conteúdo estruturado do básico ao profissional",
  },
  {
    icon: "💬",
    label: "Prática diária com acompanhamento no WhatsApp",
  },
  {
    icon: "🤖",
    label: "Tecnologia e inteligência artificial aplicadas ao aprendizado",
  },
  {
    icon: "⏱",
    label: "Flexibilidade para estudar no seu ritmo",
  },
  {
    icon: "🎯",
    label: "Aplicação real na vida e na carreira",
  },
]

const audienceLines = [
  { text: "Para quem trabalha.", delay: 0 },
  { text: "Para quem estuda.", delay: 80 },
  { text: "Para quem tem filhos, compromissos e pouco tempo — mas grandes objetivos.", delay: 160 },
]

export default function AboutSection() {
  const { ref, isVisible } = useScrollReveal()

  return (
    <section id="quem-somos" className="py-20 md:py-28 bg-gradient-to-b from-white via-gray-50/50 to-white overflow-hidden">
      <div ref={ref} className="max-w-6xl mx-auto px-5">

        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span
            className="inline-block text-sm font-bold tracking-widest uppercase mb-4 px-4 py-1.5 rounded-full"
            style={{ color: "#0E8EA0", backgroundColor: "rgba(14,142,160,0.08)" }}
          >
            Sobre nós
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Quem é a <span style={{ color: "#0E8EA0" }}>English Work</span>
          </h2>
          <div className="w-20 h-1 rounded-full mx-auto" style={{ backgroundColor: "#B038B2" }} />
        </div>

        {/* Two-column layout */}
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-start">

          {/* Left column — narrative */}
          <div
            className={`transition-all duration-700 delay-200 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-8">
              A English Work nasceu para tornar o inglês possível para quem tem{" "}
              <strong className="text-gray-900">rotina real</strong>.
            </p>

            {/* Audience pills */}
            <div className="flex flex-wrap gap-3 mb-8">
              {audienceLines.map((line, i) => (
                <span
                  key={i}
                  className={`inline-block bg-gray-100 text-gray-800 text-base md:text-lg font-medium px-4 py-2.5 rounded-xl transition-all duration-500 ${
                    isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                  }`}
                  style={{ transitionDelay: `${300 + line.delay}ms` }}
                >
                  {line.text}
                </span>
              ))}
            </div>

            <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-2">
              Nós acreditamos que aprender inglês não pode depender de sala de aula tradicional nem de métodos engessados.
            </p>
            <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
              Por isso, criamos um{" "}
              <strong className="text-gray-900">ecossistema de aprendizagem</strong> que combina:
            </p>
          </div>

          {/* Right column — checklist cards */}
          <div
            className={`space-y-4 transition-all duration-700 delay-300 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            {checkItems.map((item, i) => (
              <div
                key={i}
                className={`flex items-start gap-4 bg-white rounded-2xl p-4 md:p-5 shadow-sm border border-gray-100 hover:shadow-md hover:-translate-y-0.5 transition-all duration-500`}
                style={{ transitionDelay: `${400 + i * 100}ms` }}
              >
                <span className="flex-shrink-0 w-11 h-11 rounded-xl flex items-center justify-center text-xl" style={{ backgroundColor: "rgba(14,142,160,0.1)" }}>
                  {item.icon}
                </span>
                <span className="text-gray-700 text-base md:text-lg leading-relaxed pt-1.5">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom highlight block */}
        <div
          className={`mt-16 transition-all duration-700 delay-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="grid md:grid-cols-2 gap-6">
            {/* Journey card */}
            <div
              className="rounded-2xl p-8 md:p-10"
              style={{ backgroundColor: "rgba(14,142,160,0.05)", borderLeft: "4px solid #0E8EA0" }}
            >
              <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
                Mais do que cursos, desenvolvemos uma{" "}
                <strong className="text-gray-900">jornada completa de evolução</strong>.
              </p>
            </div>

            {/* Confidence card */}
            <div
              className="rounded-2xl p-8 md:p-10"
              style={{ backgroundColor: "rgba(176,56,178,0.05)", borderLeft: "4px solid #B038B2" }}
            >
              <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
                Aqui, você não consome aulas.
              </p>
              <p className="text-gray-900 text-xl md:text-2xl font-bold leading-relaxed mt-1">
                Você constrói confiança.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
